import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section className="w-full bg-background-100" aria-labelledby="faq-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900">
              <i className="ri-question-answer-line text-sm" aria-hidden="true"></i>
              常见问题
            </span>
            <h2
              id="faq-title"
              className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
            >
              关于吃瓜，你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们把这些年收到最多的问题整理了出来。如果还有没覆盖到的，欢迎通过页面底部的邮箱联系我们。
            </p>
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-200 border-t border-background-200">
              {faqs.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div key={item.id} className="py-1">
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpenId(isOpen ? "" : item.id)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-4 text-left"
                      >
                        <span className="font-heading text-base font-bold text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen
                              ? "bg-primary-600 text-background-50"
                              : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          <i
                            className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}